import { CUSTOM_FEATURE_REQUEST_CONFIG } from "../constants/CustomFeatureRequestFooter.constants";
import { FEATURE_STATUS } from "features/Account/Account.constants";

export const mergeStatusConfig = (statusConfig = {}) => {
  return {
    default: {
      ...CUSTOM_FEATURE_REQUEST_CONFIG.default,
      ...statusConfig.default,
    },
    [FEATURE_STATUS.ACCESS_LOCKED]: {
      ...CUSTOM_FEATURE_REQUEST_CONFIG[FEATURE_STATUS.ACCESS_LOCKED],
      ...statusConfig[FEATURE_STATUS.ACCESS_LOCKED],
    },
    [FEATURE_STATUS.ACCESS_REQUESTED]: {
      ...CUSTOM_FEATURE_REQUEST_CONFIG[FEATURE_STATUS.ACCESS_REQUESTED],
      ...statusConfig[FEATURE_STATUS.ACCESS_REQUESTED],
    },
    [FEATURE_STATUS.ACCESS_DENIED]: {
      ...CUSTOM_FEATURE_REQUEST_CONFIG[FEATURE_STATUS.ACCESS_DENIED],
      ...statusConfig[FEATURE_STATUS.ACCESS_DENIED],
    },
    [FEATURE_STATUS.ACCESS_GRANTED]: {
      ...CUSTOM_FEATURE_REQUEST_CONFIG[FEATURE_STATUS.ACCESS_GRANTED],
      ...statusConfig[FEATURE_STATUS.ACCESS_GRANTED],
    },
  };
};

export const getCurrentStatusConfig = (mergedConfig, currentStatus) => {
  return mergedConfig[currentStatus] || mergedConfig.default || {};
};

export const applyCustomConfigOverrides = (
  requestVerificationConfig,
  customConfig = {}
) => {
  return {
    ...requestVerificationConfig,
    text: { ...requestVerificationConfig.text, ...customConfig.text },
    backgroundColor:
      customConfig.backgroundColor || requestVerificationConfig.backgroundColor,
    btn: { ...requestVerificationConfig.btn, ...customConfig.btn },
  };
};
